// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentionTextarea_wrapper__UVYWb {
  position: relative;
}

.MentionTextarea_textarea__YHBHI {
  width: 100%;
}

.MentionTextarea_dropdown__qf3bX {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(100% + 8px);
  display: grid;
  gap: 4px;
  padding: 8px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 12px;
  background: var(--cl-surface, #fff);
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.14);
  z-index: 30;
  max-height: 220px;
  overflow-y: auto;
}

.MentionTextarea_item__cO-d7,
.MentionTextarea_itemActive__oHvA9 {
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
  background: transparent;
  color: var(--cl-dark, #1f2937);
}

.MentionTextarea_item__cO-d7:hover,
.MentionTextarea_itemActive__oHvA9 {
  background: rgba(64, 150, 255, 0.14);
}`, "",{"version":3,"sources":["webpack://./src/Components/MentionTextarea/MentionTextarea.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,mCAAA;EACA,8CAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;AACF;;AAEA;;EAEE,oCAAA;AACF","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.textarea {\n  width: 100%;\n}\n\n.dropdown {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: calc(100% + 8px);\n  display: grid;\n  gap: 4px;\n  padding: 8px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 12px;\n  background: var(--cl-surface, #fff);\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.14);\n  z-index: 30;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.item,\n.itemActive {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 12px;\n  text-align: left;\n  cursor: pointer;\n  background: transparent;\n  color: var(--cl-dark, #1f2937);\n}\n\n.item:hover,\n.itemActive {\n  background: rgba(64, 150, 255, 0.14);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MentionTextarea_wrapper__UVYWb`,
	"textarea": `MentionTextarea_textarea__YHBHI`,
	"dropdown": `MentionTextarea_dropdown__qf3bX`,
	"item": `MentionTextarea_item__cO-d7`,
	"itemActive": `MentionTextarea_itemActive__oHvA9`
};
export default ___CSS_LOADER_EXPORT___;
